var symphony = symphony || {};

;
(function () {

    symphony.accordionDisplay = function () {
        $(document).on('click', '.section.accordionGroup input[type="checkbox"]', function () {
            if (this.checked) {
                var checkboxes = document.querySelectorAll('.section.accordionGroup input[type="checkbox"][name="' + this.name + '"]');
                if (checkboxes.length > 0) {
                    for (var i = 0; i < checkboxes.length; i++) {
                        checkboxes[i].checked = checkboxes[i].id == this.id;
                    }
                }

                var self = this;
                setTimeout( function() {
                    var $label = $(self).next();
                    symphony.site.animateScrollTo($label, -51, 350);
                }, 400)
            }
        });
    };
})();
